import { Component, Input, Output, EventEmitter, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';
import { CuestionariosService } from '../services/cuestionarios.service';
import { IPregunta } from '../interfaces/pregunta.interface';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-preguntas-dialog',
  templateUrl: './preguntas-dialog.component.html',
  providers: [MessageService]
})
export class PreguntasDialogComponent implements OnInit, OnChanges {
  @ViewChild('dt') table!: Table;
  @Input() displayDialog: boolean = false;
  @Input() cuestionario: any = null;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() onHide = new EventEmitter<{refresh: boolean}>();

  dataSource: IPregunta[] = [];
  loading: boolean = false;
  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  displayNuevaPreguntaDialog: boolean = false;
  modoEdicion: boolean = false;
  preguntaSeleccionada: any = null;

  displayedColumns = [
    { field: 'iNumPreg', header: 'N° Pregunta', sortable: true },
    { field: 'sQuePregunta', header: 'Pregunta', sortable: true },
    { field: 'sTabla', header: 'Tabla', sortable: true },
    { field: 'sTipo', header: 'Tipo', sortable: true },
    { field: 'sCampo', header: 'Campo', sortable: true },
    { field: 'amg', header: 'A/M/G', sortable: true },
    { field: 'actions', header: 'Acciones', sortable: false }
  ];

  constructor(
    private messageService: MessageService,
    private cuestionariosService: CuestionariosService
  ) {}

  ngOnInit(): void {
    console.log('ngOnInit - Cuestionario:', this.cuestionario);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('ngOnChanges - Cambios:', changes);
    if (changes['cuestionario'] && changes['cuestionario'].currentValue) {
      console.log('Cuestionario actualizado:', changes['cuestionario'].currentValue);
      this.loadData();
    }
  }

  loadData(): void {
    console.log('loadData - Cuestionario:', this.cuestionario);
    if (this.cuestionario?.sClaveCues) {
      this.loading = true;
      console.log('Llamando al servicio con clave:', this.cuestionario.sClaveCues);
      this.cuestionariosService.getPreguntas(this.cuestionario.sClaveCues).subscribe({
        next: (response) => {
          console.log('Respuesta del servicio:', response);
          if (response.success) {
            this.dataSource = response.data.map((item: IPregunta) => ({
              ...item,
              amg: `${item.bActualizar}/${item.bGrabar}/${item.bMostrar}`
            }));
            this.totalRecords = this.dataSource.length;
            console.log('Datos cargados:', this.dataSource);
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se pudieron cargar las preguntas'
            });
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al cargar preguntas:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar las preguntas'
          });
          this.loading = false;
        }
      });
    } else {
      console.log('No hay clave de cuestionario disponible');
    }
  }

  onPage(event: any): void {
    this.first = event.first;
    this.rows = event.rows;
    this.loadData();
  }

  onDialogClosed(): void {
    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
    this.onHide.emit({ refresh: false });
  }

  openNuevaPregunta(): void {
    this.modoEdicion = false;
    this.preguntaSeleccionada = null;
    this.displayNuevaPreguntaDialog = true;
  }

  editarPregunta(pregunta: any): void {
    this.modoEdicion = true;
    this.preguntaSeleccionada = pregunta;
    this.displayNuevaPreguntaDialog = true;
  }

  onNuevaPreguntaDialogClosed(event: {refresh: boolean}): void {
    this.displayNuevaPreguntaDialog = false;
    if (event?.refresh) {
      this.loadData();
    }
  }

  eliminarPregunta(iNumPreg: number): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar esta pregunta?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        const request = {
          que: 3,
          sClaveCues: this.cuestionario.sClaveCues,
          iNumPreg: iNumPreg,
          sQuePregunta: "",
          sTabla: "",
          sTipo: "",
          sCampo: "",
          iTipoResp: 0,
          bActualizar: 0,
          bMostrar: 0,
          bGrabar: 0
        };

        this.cuestionariosService.eliminarPregunta(request).subscribe({
          next: (response) => {
            if (response.success && response.data.error === 0) {
              this.messageService.add({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Pregunta eliminada correctamente'
              });
              this.loadData();
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No se pudo eliminar la pregunta'
              });
            }
          },
          error: (error) => {
            console.error('Error al eliminar pregunta:', error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se pudo eliminar la pregunta'
            });
          },
          complete: () => {
            this.loading = false;
          }
        });
      }
    });
  }
} 